export default __webpack_public_path__ + "static/media/image 4.c8f74de7.png";